import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function RoleFilter({ value, onChange }) {
    return (
        <TextField
            value={value}
            onChange={(event) => onChange(event.target.value)}
            label="Rechercher un rôle"
            placeholder="Nom du rôle"
            size="small"
            fullWidth
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                    </InputAdornment>
                ),
            }}
        />
    );
}
